export const interiorView08ImageOptions = {
  angle: 'InteriorView08',
  staticOptions: {
    Fabric: 1,
    FabricOwners: 1
  },
  mattes: [],
  overlays: []
}



// WEBPACK FOOTER //
// ./src/Xr41/views/InteriorView08.js